<template>
	<LazyVisibleSectionContentItem
		v-for="item in $tm('residential.installation-cta.copy')"
		:key="item"
		:copy="item"
		:viewbox="viewbox"
		:image="image"
		class="mb-8 lg:mb-0"
		image-classes="flex shrink-0 w-full justify-center items-center max-w-[280px] sm:max-w-[280px] lg:max-w-[260px] xl:max-w-[405px] mx-auto mt-16 lg:mt-0"
		hydrate-on-visible
		:ui="{
			features: '-ml-1',
			leading: 'hidden',
			container: 'lg:items-center'
		}"
	>
		<template #cta>
			<div class="w-full flex justify-center md:justify-start md:ml-2">
				<UButton
					class="uppercase max-w-sm md:max-w-md h-12 text-center"
					:to="localePath('/installation-overview')"
					:label="$t('residential.installation-cta.link-text')"
					:ui="{
						label: 'text-wrap'
					}"
				/>
			</div>
		</template>
	</LazyVisibleSectionContentItem>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const localePath = useLocalePath()
const { t } = useI18n({
	useScope: 'global'
})

const viewbox = {
	width: 300,
	height: 212
}

const image = {
	url: '/images/maverix-broadband-site-survey.webp',
	alt: 'Maverix Fiber-fast internet'
}
</script>
